<div class="modal-container" data-testid="company-join-modal">
  <div class="modal-header">
    <span>{{ 'modal.join_group.title' | translate }}</span>
  </div>
  <div class="seperator">
    <hr />
  </div>
  <div class="modal-body">
    <span *ngIf="!errorMessage">
      {{
        'modal.join_group.invite_text' | translate: { companyName: companyName }
      }}
    </span>
    <span class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </span>
    <ng-container *ngIf="company$ | async; let company">
      <div class="modal-content">
        <div class="message" *ngIf="!!company.id">
          <img
            class="icon-upload"
            src="../assets/svg/icon-warning.svg"
            alt="warning symbol"
          />
          <span>
            {{ 'modal.join_group.warning_text' | translate }}
          </span>
        </div>
        <div class="buttons">
          <app-button
            [title]="'modal.join_group.cancel' | translate"
            (click)="abortModal()"
          ></app-button>
          <app-button
            [disabled]="!!company.id"
            testId="company-join-accept"
            [title]="'modal.join_group.accept' | translate"
            (click)="finishModal()"
          ></app-button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
